var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 128.6677 348.7807)",
    style: {
      fill: "#fff",
      fontFamily: "'Poppins-Black'",
      fontSize: "39.5129px",
      letterSpacing: 5
    }
  }, "Data Mapper "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M284.185,268.122c-5.223,0-9.662,3.41-11.214,8.12h-8.74l-32.447-32.447 c-0.692-0.692-1.629-1.08-2.607-1.08h-9.656c-2.036,0-3.687,1.651-3.687,3.687c0,2.036,1.65,3.687,3.687,3.687h8.129 l32.447,32.447c0.692,0.691,1.629,1.08,2.607,1.08h10.267c1.552,4.71,5.991,8.12,11.214,8.12c6.511,0,11.807-5.297,11.807-11.807 C295.992,273.419,290.696,268.122,284.185,268.122z M284.185,284.362c-2.444,0-4.433-1.989-4.433-4.433 c0-2.444,1.988-4.433,4.433-4.433c2.445,0,4.433,1.989,4.433,4.433C288.618,282.374,286.629,284.362,284.185,284.362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M236.379,267.716c-5.223,0-9.662,3.41-11.214,8.12h-17.469c-2.036,0-3.687,1.651-3.687,3.687 c0,2.036,1.651,3.687,3.687,3.687h17.469c1.552,4.71,5.991,8.12,11.214,8.12c6.511,0,11.807-5.297,11.807-11.807 C248.186,273.013,242.889,267.716,236.379,267.716z M236.379,283.957c-2.151,0-3.947-1.54-4.348-3.575 c0.066-0.276,0.105-0.562,0.105-0.859c0-0.296-0.039-0.583-0.105-0.858c0.401-2.035,2.197-3.575,4.348-3.575 c2.445,0,4.433,1.989,4.433,4.433C240.812,281.968,238.823,283.957,236.379,283.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M303.307,234.595c-5.223,0-9.662,3.41-11.214,8.12h-36.592c-2.036,0-3.687,1.651-3.687,3.687 c0,2.036,1.65,3.687,3.687,3.687h36.592c1.552,4.71,5.991,8.12,11.214,8.12c6.511,0,11.807-5.297,11.807-11.807 C315.115,239.891,309.818,234.595,303.307,234.595z M303.307,250.835c-2.445,0-4.433-1.989-4.433-4.433 c0-2.444,1.988-4.433,4.433-4.433c2.444,0,4.433,1.989,4.433,4.433C307.741,248.846,305.752,250.835,303.307,250.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M322.43,201.258c-5.223,0-9.662,3.41-11.215,8.12h-79.518c-0.978,0-1.915,0.388-2.607,1.08 l-32.257,32.257h-8.26c-2.036,0-3.687,1.651-3.687,3.687c0,2.036,1.65,3.687,3.687,3.687h9.788c0.978,0,1.915-0.388,2.607-1.08 l32.257-32.257h77.991c1.552,4.71,5.991,8.12,11.215,8.12c6.51,0,11.807-5.297,11.807-11.807 C334.237,206.554,328.94,201.258,322.43,201.258z M322.43,217.497c-2.445,0-4.433-1.989-4.433-4.433 c0-2.445,1.989-4.433,4.433-4.433c2.444,0,4.433,1.989,4.433,4.433C326.863,215.509,324.875,217.497,322.43,217.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M292.093,176.473h-42.861c-2.036,0-3.687,1.651-3.687,3.687c0,2.036,1.65,3.687,3.687,3.687h42.861 c1.552,4.71,5.991,8.12,11.214,8.12c6.511,0,11.807-5.297,11.807-11.807c0-6.51-5.297-11.807-11.807-11.807 C298.085,168.353,293.646,171.763,292.093,176.473z M303.307,175.727c2.444,0,4.433,1.989,4.433,4.433s-1.989,4.433-4.433,4.433 c-2.445,0-4.433-1.989-4.433-4.433S300.863,175.727,303.307,175.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M200.849,225.088c6.511,0,11.807-5.297,11.807-11.807c0-6.51-5.296-11.807-11.807-11.807 c-5.223,0-9.661,3.41-11.214,8.12H169.45c-2.036,0-3.687,1.651-3.687,3.687c0,2.036,1.65,3.687,3.687,3.687h20.186 C191.188,221.678,195.627,225.088,200.849,225.088z M200.849,208.848c2.445,0,4.433,1.989,4.433,4.433 c0,2.444-1.989,4.433-4.433,4.433c-2.444,0-4.433-1.989-4.433-4.433C196.417,210.837,198.405,208.848,200.849,208.848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M188.573,183.847h39.594c0.978,0,1.915-0.388,2.607-1.08l31.838-31.838h10.428 c1.612,4.604,5.998,7.917,11.145,7.917c6.511,0,11.807-5.297,11.807-11.807c0-6.51-5.297-11.807-11.807-11.807 c-5.298,0-9.792,3.508-11.282,8.323h-11.819c-0.978,0-1.915,0.388-2.607,1.08l-31.838,31.838h-38.067 c-2.036,0-3.687,1.651-3.687,3.687C184.886,182.196,186.536,183.847,188.573,183.847z M284.185,142.605 c2.445,0,4.433,1.989,4.433,4.433c0,2.444-1.989,4.433-4.433,4.433c-2.444,0-4.433-1.989-4.433-4.433 C279.752,144.594,281.74,142.605,284.185,142.605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M207.695,150.725h11.977c1.552,4.71,5.991,8.12,11.214,8.12c6.511,0,11.807-5.297,11.807-11.807 c0-6.51-5.296-11.807-11.807-11.807c-5.223,0-9.662,3.41-11.214,8.12h-11.977c-2.036,0-3.687,1.651-3.687,3.687 C204.008,149.075,205.659,150.725,207.695,150.725z M230.886,142.605c2.444,0,4.433,1.989,4.433,4.433 c0,2.444-1.989,4.433-4.433,4.433c-2.445,0-4.433-1.989-4.433-4.433C226.453,144.594,228.441,142.605,230.886,142.605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M219.521,194.154c-1.358,0-2.458,1.1-2.458,2.458s1.1,2.458,2.458,2.458h69.001 c1.358,0,2.458-1.1,2.458-2.458s-1.1-2.458-2.458-2.458H219.521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M288.522,232.299c1.358,0,2.458-1.1,2.458-2.458s-1.1-2.458-2.458-2.458h-48.233 c-1.358,0-2.458,1.1-2.458,2.458s1.1,2.458,2.458,2.458H288.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M275.344,265.42c1.358,0,2.458-1.101,2.458-2.458s-1.1-2.458-2.458-2.458h-15.572 c-1.358,0-2.458,1.1-2.458,2.458s1.1,2.458,2.458,2.458H275.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M275.344,166.165c1.358,0,2.458-1.1,2.458-2.458c0-1.357-1.1-2.458-2.458-2.458h-15.572 c-1.358,0-2.458,1.101-2.458,2.458c0,1.357,1.1,2.458,2.458,2.458H275.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M202.5,166.165h15.572c1.358,0,2.458-1.1,2.458-2.458c0-1.357-1.1-2.458-2.458-2.458H202.5 c-1.358,0-2.458,1.101-2.458,2.458C200.042,165.065,201.142,166.165,202.5,166.165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M207.194,265.42h15.572c1.358,0,2.458-1.101,2.458-2.458s-1.1-2.458-2.458-2.458h-15.572 c-1.358,0-2.458,1.1-2.458,2.458S205.836,265.42,207.194,265.42z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cb650489f70d05253be7874225157f81.svg";
export { ForwardRef as ReactComponent };